<script setup lang="ts">

import TapSection from '@/components/TapSection.vue'
import DailyPrizeBox from '@/components/DailyPrizeBox.vue'
import { useDailyCipher } from '@/composables/game/daily'
import { markRaw, ref } from 'vue'
import DailyCipherOverlay from '@/components/overlays/DailyCipherOverlay.vue'
import type { PlayerStats } from '@/types/shared/player'
import { usePlayer } from '@/composables/game/player'
import { useAnimateCoins, useFlyingCoins } from '@/composables/game/flying-coins'
import { useToaster } from '@/composables/game/toasters'
import { useConfig } from '@/composables/game/config'
import SpinnerIcon from '@/components/icons/SpinnerIcon.vue'

defineEmits(['isTapping'])

const { isDailyCipherDone } = useDailyCipher()
const { updatePlayer } = usePlayer()
const { startCoinAnimation } = useFlyingCoins()
const { notify } = useToaster()
const { config } = useConfig()
const { doAnimateCoins } = useAnimateCoins()

const decipheredLetters = ref('')
const showDailyCipherOverlay = ref(false)
const playerStatsToUpdate = ref<PlayerStats | null>(null)

function onCipherDone(playerStats: PlayerStats) {
  setTimeout(() => {
    showDailyCipherOverlay.value = true
    playerStatsToUpdate.value = playerStats
  }, 850)
}

function updatePlayerStats() {
  if (!playerStatsToUpdate.value) return
  notify({ title: 'Requesting claim...', icon: markRaw(SpinnerIcon), duration: 1000 })
  doAnimateCoins()
  setTimeout(() => {
    showDailyCipherOverlay.value = false
    notify({ title: 'Claim success!', type: 'success' })
    startCoinAnimation()
    updatePlayer(playerStatsToUpdate.value as PlayerStats)
  }, 1000)
}
</script>

<template>
  <DailyPrizeBox
    class="mt-3"
    title="Fight FUD"
    :prize="config.game.challenges.dailyCipher.reward"
    :is-done="isDailyCipherDone"
    :letters="decipheredLetters"
  />
  <TapSection
    hide-actions
    is-cipher
    :is-cipher-done="isDailyCipherDone"
    @is-tapping="$emit('isTapping', $event)"
    @deciphered-letters-change="decipheredLetters = $event"
    @cipher-done="onCipherDone"
  />

  <DailyCipherOverlay
    v-if="showDailyCipherOverlay"
    :class="showDailyCipherOverlay ? 'z-[999] opacity-100' : '-z-[1] opacity-0'"
    :show="showDailyCipherOverlay"
    @click="updatePlayerStats()"
  />
</template>

<style scoped>

</style>
